import { FormActionDef, FormDefine } from '@/libs/formHelper/form/type'
import { SysConfigQuery } from '@/api/sys/SysConfigQuery'
import { SysConfig } from '@/api/sys/SysConfig'

export default function getFormDefine (view: any): FormDefine<SysConfigQuery> {
  const items = [{
    title: '配置名称',
    clearable: true,
    hideLabel: true,
    key: 'name'
  }, {
    title: 'key',
    clearable: true,
    hideLabel: true,
    key: 'keyCode'
  }]

  const actions: FormActionDef<SysConfig>[] = [{
    key: 'search',
    title: '查询',
    button: 'primary',
    icon: 'ios-search',
    onClick: (_item: SysConfig) => {
      view.onSearch()
    }
  },
  {
    key: 'add',
    title: '新增',
    icon: 'ios-add',
    onClick: (_item: SysConfig) => {
      view.onNewItem()
    }
  }]

  return {
    items,
    actions,
    enterTrigger: view.onSearch
  }
}
